import { Box, Button, DialogActions, DialogContent, Divider } from "@mui/material";
import { useForm } from "react-hook-form";
import { useStore } from "../../../store/store";
import { Wysiwyg } from "../../../components/wysiwyg/Wysiwyg";
import { Close as CloseIcon, Save as SaveIcon } from "@mui/icons-material";
import { FieldExtraOption, FormatedField } from "../../../types/fields.types";

type EvaluationsContentDialogProps = {
    field: FormatedField;
    initialContent: string | null;
    extraOptions?: FieldExtraOption | null;
    onSave: (content: string) => Promise<void>;
};

export const EvaluationsContentDialog = ({
    field,
    initialContent,
    extraOptions,
    onSave,
}: EvaluationsContentDialogProps) => {
    const { appDialog, notifications } = useStore();
    const entityForm = useForm({
        mode: "onChange",
        defaultValues: {
            [field.field]: initialContent || "",
        },
    });

    const { isSubmitting } = entityForm.formState;

    const onSubmit = async (formData: any) => {
        formData[field.field] = formData.content;
        try {
            await onSave(formData[field.field]);
            notifications.setNotification({
                isOpen: true,
                message: "Interpretação de Resultados atualizada com sucesso.",
                severity: "success",
            });
            appDialog.toggleIsOpen();
        } catch (error: any) {
            notifications.setNotification({
                isOpen: true,
                message: error.response.data.errors[0].message,
                severity: "error",
            });
        }
    };

    return (
        <Box component="form" onSubmit={entityForm.handleSubmit(onSubmit)}>
            <DialogContent>
                <Divider sx={{ mb: 4 }} />
                <Wysiwyg
                    entityForm={entityForm}
                    initialValue={initialContent || ""}
                    field={field}
                    size={extraOptions?.style?.height || "500px"}
                    toolbarItems={extraOptions?.style?.toolbarItems}
                    noParagraphSpacing={extraOptions?.style?.noParagraphSpacing}
                    canMention={false}
                />
            </DialogContent>
            <DialogActions sx={{ padding: 4 }}>
                <Button
                    disabled={isSubmitting}
                    onClick={() => appDialog.toggleIsOpen()}
                    color="secondary"
                    startIcon={<CloseIcon />}
                >
                    Cancelar
                </Button>
                <Button
                    disabled={isSubmitting}
                    type="submit"
                    color="primary"
                    variant="contained"
                    startIcon={<SaveIcon />}
                >
                    {isSubmitting ? "Guardar..." : "Guardar"}
                </Button>
            </DialogActions>
        </Box>
    );
};
